import { FC, PropsWithChildren, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import BHLogoUrl from '../../assets/hkbaptist.png';
import BHMobileLogoUrl from '../../assets/hkbaptist_mobi.png';
import AMCLogoUrl from '../../assets/hkbh_amc.png';
import AMCMobileLogoUrl from '../../assets/hkbh_amc_mobi.png';
import EKMCLogoUrl from '../../assets/hkbh_ekmc.png';
import EKMCMobileLogoUrl from '../../assets/hkbh_ekmc_mobi.png';
import styles from './Layout.module.scss';
import LanguageSwitcher from '../LanguageSwitcher';

interface LayoutProps {
  isFormValuesDirty: boolean;
  backgroundVariant?: "default" | "internal";
  logoVariant?: 'site' | 'bh-ekmc' | 'bh' | 'ekmc';
}

const Layout: FC<PropsWithChildren<LayoutProps>> = ({
  children,
  isFormValuesDirty,
  backgroundVariant = "default",
  logoVariant = 'site',
}) => {
  const [searchParams] = useSearchParams();
  const cmsSiteId = searchParams.get('site') ?? searchParams.get('cmsSiteId') ?? '';
  const logoSiteId =
    logoVariant === 'bh'
      ? 'BH'
      : logoVariant === 'ekmc'
        ? 'EKMC'
        : cmsSiteId.toUpperCase();

  useEffect(() => {
    const internalBackgroundClass = "internal-booking-background";
    document.documentElement.classList.toggle(
      internalBackgroundClass,
      backgroundVariant === "internal"
    );

    return () =>
      document.documentElement.classList.remove(internalBackgroundClass);
  }, [backgroundVariant]);

  return (
    <div className={styles.container}>
      <LanguageSwitcher isFormValuesDirty={isFormValuesDirty} />
      <div style={{ display: "none" }}>Version: 1.1.0</div>
      {logoVariant === 'bh-ekmc' ? (
        <div className={styles.dualLogoGroup}>
          <picture className={styles.dualLogoPicture}>
            <source media="(max-width: 696px)" srcSet={BHMobileLogoUrl} />
            <img
              src={BHLogoUrl}
              alt="Hong Kong Baptist Hospital logo"
              className={styles.dualLogo}
            />
          </picture>
          <picture className={styles.dualLogoPicture}>
            <source media="(max-width: 696px)" srcSet={EKMCMobileLogoUrl} />
            <img
              src={EKMCLogoUrl}
              alt="HKBH East Kowloon Medical Centre logo"
              className={styles.dualLogo}
            />
          </picture>
        </div>
      ) : (
        <>
          <img
            src={
              logoSiteId === 'AMC'
                ? AMCLogoUrl
                : logoSiteId === 'EKMC'
                  ? EKMCLogoUrl
                  : BHLogoUrl
            }
            alt="Logo"
            className={styles.icon}
          />
          <img
            src={
              logoSiteId === 'AMC'
                ? AMCMobileLogoUrl
                : logoSiteId === 'EKMC'
                  ? EKMCMobileLogoUrl
                  : BHMobileLogoUrl
            }
            alt="Logo"
            className={styles.mobileIcon}
          />
        </>
      )}
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default Layout;
